exports.APPLICATION = 1;
exports.CLASS = 2;
exports.INSTANCE = 3;
exports.NONE = 4;



//////////////////
// WEBPACK FOOTER
// ./~/jpex/src/constants.js
// module id = 138
// module chunks = 0